import { isPercentAllowed } from './models.js';
export const BASE_WHEEL_PER_STAR_COST = 1;
export function isDestiny(category) { return category?.isDestiny === true; }
export function canCharacterJoinCategory(character, category) { return !category.isDestiny || character.rarity !== 'UR'; }
export function perStarWheelCost(member, category) { return category.isDestiny ? member.perStarWheelCost : BASE_WHEEL_PER_STAR_COST; }
export function perRankFragmentCost(member, character, category) {
    return category.isDestiny && member.perRankFragmentCostOverride !== undefined
        ? member.perRankFragmentCostOverride
        : category.isDestiny ? character.destinyRankFragmentCost : character.baseRankFragmentCost;
}
/**
 * 命轮的显示状态是“阶 + 当前星”，而不是累计星数。
 * 每次升阶前必须走完一整轮星级，升阶后当前星归零；满阶固定显示为零星。
 */
export function isValidWheelStage(rank, star, maxStar, maxRank) {
    return Number.isInteger(rank) && Number.isInteger(star)
        && rank >= 0 && rank <= maxRank
        && star >= 0 && star <= maxStar
        && !(rank === maxRank && star !== 0);
}
/** 已实际完成的升星次数，包含每次升阶前被清零的满星过程。 */
export function completedStarUpgrades(rank, star, maxStar) { return rank * maxStar + star; }
export function wheelStageLabel(rank, star, maxRank) {
    return rank === maxRank && star === 0 ? '满阶' : `${rank}阶 ${star}星`;
}
export function calculateRawAttributes(workbench, gains) {
    const sourceById = new Map(workbench.sourceAttributes.map((source) => [source.id, source]));
    const values = new Map();
    for (const gain of gains) {
        const source = sourceById.get(gain.sourceAttributeId);
        if (!source)
            throw new Error(`未找到固定源词条：${gain.sourceAttributeId}`);
        if (gain.valueKind === 'percent' && !isPercentAllowed(gain.sourceAttributeId))
            throw new Error(`${source.name} 只允许数值类型。`);
        const key = `${gain.sourceAttributeId}\u0000${gain.valueKind}`;
        values.set(key, (values.get(key) ?? 0) + gain.value);
    }
    return [...values].map(([key, value]) => {
        const [sourceAttributeId, valueKind] = key.split('\u0000');
        return { sourceAttributeId, valueKind, value };
    }).sort((left, right) => (sourceById.get(left.sourceAttributeId)?.order ?? 0) - (sourceById.get(right.sourceAttributeId)?.order ?? 0) || (left.valueKind === 'flat' ? -1 : 1));
}
export function calculateIncrements(workbench, baseAttributes, gains) {
    const base = new Map([...baseAttributes].map((item) => [item.metricId, item.value]));
    const flat = new Map(workbench.optimizationMetrics.map((metric) => [metric.id, 0]));
    const percent = new Map(workbench.optimizationMetrics.map((metric) => [metric.id, 0]));
    const sourceById = new Map(workbench.sourceAttributes.map((source) => [source.id, source]));
    for (const gain of calculateRawAttributes(workbench, gains)) {
        const targets = sourceById.get(gain.sourceAttributeId)?.targetMetricIds ?? [];
        const percentMode = sourceById.get(gain.sourceAttributeId)?.percentMode ?? 'relative';
        for (const metricId of targets) {
            const target = gain.valueKind === 'flat' || percentMode === 'points' ? flat : percent;
            target.set(metricId, (target.get(metricId) ?? 0) + gain.value);
        }
    }
    for (const metric of workbench.optimizationMetrics)
        flat.set(metric.id, (flat.get(metric.id) ?? 0) + (base.get(metric.id) ?? 0) * (percent.get(metric.id) ?? 0) / 100);
    return Object.fromEntries(flat);
}
export function allGainsForResult(workbench, result) {
    const wheelById = new Map(workbench.fateWheels.map((wheel) => [wheel.id, wheel]));
    const gains = [];
    for (const line of result.fateWheels) {
        const wheel = wheelById.get(line.fateWheelId);
        if (!wheel)
            continue;
        const starUpgrades = completedStarUpgrades(line.rank, line.star, wheel.maxStar);
        for (const gain of wheel.perStarGains)
            for (let step = 0; step < starUpgrades; step += 1)
                gains.push(gain);
        for (const gain of wheel.perRankGains)
            for (let step = 0; step < line.rank; step += 1)
                gains.push(gain);
    }
    return gains;
}
//# sourceMappingURL=rules.js.map